/**
 * As seções do PDF do cliente, na ordem das páginas: as mesmas chaves que a rota
 * aceita em `?sections=` (`CLIENT_SECTIONS` do `client_pdf.py`). A capa não está
 * aqui porque sai sempre (EF-DIAG-005 RF-01).
 */
export const CLIENT_PDF_SECTIONS = [
  { key: "summary", label: "Summary" },
  { key: "users_and_companies", label: "Users and companies" },
  { key: "processes", label: "Processes (scope items)" },
  { key: "chart_of_accounts", label: "Chart of accounts" },
  { key: "developments", label: "Custom developments (WRICEF)" },
  { key: "volumes", label: "Consumption and volumes" },
  { key: "next_steps", label: "Next steps" },
] as const;

export type ClientPdfSection = (typeof CLIENT_PDF_SECTIONS)[number]["key"];
